import { render, staticRenderFns } from "./PricingSheetBody.vue?vue&type=template&id=cd046a4c&scoped=true&"
import script from "./PricingSheetBody.vue?vue&type=script&lang=js&"
export * from "./PricingSheetBody.vue?vue&type=script&lang=js&"
import style0 from "./PricingSheetBody.vue?vue&type=style&index=0&id=cd046a4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd046a4c",
  null
  
)

export default component.exports